export const environment = {
    production: false,
    baseUrl: 'https://beml.livnsense.com/api/',
    // baseUrl: 'https://api-alv.vicas.livnsense.com/api/'
    // baseUrl: 'https://api-vicas.ap.autoliv.int/api/',
    // baseUrl: 'http://10.18.12.49:9332/',
    // shashi Url-----
    // baseUrl: 'http://192.168.2.40:9000/api/',
    // Sarita Url------
    // baseUrl: 'http://192.168.2.86:8002/api/'
    // Ayush Url------
    // baseUrl: 'http://192.168.2.40:8000/api/'
      // baseUrl: 'http://localhost:8085/'
    //  baseUrl:'http://localhost:8089/api/'
    // baseUrl:'http://localhost:8087/'
  };


